export default __webpack_public_path__ + "static/media/salon.3df71d1e.png";